import { FormikProps } from 'formik'
import React from 'react'

interface FormValues {
  gender: string
  birthDate: string
  countryOfBirthName: string
  countryOfBirthCode:string
  street: string
  city: string
  zipCode: string
  occupation: string
  transactionPerMonth: string
  
numberTransactionsPerMonth: string
}
interface Props {
  formik: FormikProps <FormValues>
  residentialCountry:string
}


const ProfileStepTwo: React.FC<Props> = ({ formik, residentialCountry }) => {

  return (
    <div className="flex flex-col sm:items-center gap-4 w-full">
      <h3 className="text-[#AEB6FB] font-bold">Étape 1</h3>
      <div className='h3'>Votre adresse</div>
          <input
            className={` cursor-default rounded-[16px] border border-[#AEB6FB] focus:border-[#5754E5] h-[56px] sm:h-[48px] text-[#5754E5] text-[16px] px-[10px] w-full outline-none mb-[15px] sm:mb-[10px]`}
            name="residentialCountry"
            value={residentialCountry}
            readOnly          
          />

        <div className='w-full'>
          <input
            className={` placeholder:text-[#D1D1FF] rounded-[16px] border border-[#AEB6FB] focus:border-[#5754E5] h-[56px] sm:h-[48px] text-[#5754E5] text-[16px] px-[10px] w-full outline-none`}
            name="street"
            placeholder="Adresse de Résidence"
            value={formik.values.street}
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />

          <p className="text-[#EE443F] w-full text-[10px] mt-1 h-[15px] sm:h-[10px]">
            {formik.touched.street && formik.errors.street}
          </p>
        </div>

        <div className='w-full flex gap-6 sm:gap-2'>
        <div className='w-1/3'>
          <input
            className={` placeholder:text-[#D1D1FF] rounded-[16px] border border-[#AEB6FB] focus:border-[#5754E5] h-[56px] sm:h-[48px] text-[#5754E5] text-[16px] px-[10px] w-full outline-none`}
            name="zipCode"
            placeholder="Code Postal"
            value={formik.values.zipCode}
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />

          <p className="text-[#EE443F] w-full text-[10px] mt-1 h-[15px] sm:h-[10px]">
            {formik.touched.zipCode && formik.errors.zipCode}
          </p>
        </div>

         <div className='w-2/3'>
          <input
            className={` placeholder:text-[#D1D1FF] rounded-[16px] border border-[#AEB6FB] focus:border-[#5754E5] h-[56px] sm:h-[48px] text-[#5754E5] text-[16px] px-[10px] w-full outline-none`}
            name="city"
            placeholder="Ville"
            value={formik.values.city}
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />

          <p className="text-[#EE443F] w-full text-[10px] mt-1 h-[15px] sm:h-[10px]">
            {formik.touched.city && formik.errors.city}
          </p>
        </div>

        </div>
       

      
    </div>
  )
}

export default ProfileStepTwo
